export default "__VITE_ASSET__UnOJkREj__"